import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { Heading } from '@grandvisionhq/elements';
import NewsletterForm from './NewsletterForm.js';

var Newsletter = (_param)=>{
    var { alert , content , hideForm , title  } = _param, newsletterFormProps = swcHelpers.objectWithoutProperties(_param, [
        "alert",
        "content",
        "hideForm",
        "title"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "newsletter__content-wrapper"
    }, title && /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small"
    }, title), alert, content, !hideForm ? /*#__PURE__*/ React__default.createElement(NewsletterForm, swcHelpers.extends({}, newsletterFormProps)) : null);
};

export { Newsletter };
//# sourceMappingURL=Newsletter.js.map
